import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../../hooks/useFetchData";
import { getMyModerationDataActionHandler } from "../../../../store/actions/actionHandlers/socialActionHandler";
import { moderateContributions } from "../../../../utils/mainTabs/social/moderateContributions";
import { myModerations } from "../../../../utils/mainTabs/social/myModerations";

const MyModerations = () => {
  const pageSize = 8;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tenantName } = useOutletContext();
  const [tableColumns, setTableColumns] = useState([]);
  const { searchPlaceHolder } = myModerations;
  const { columns } = moderateContributions;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getMyModerationDataActionHandler, pageSize);

  useEffect(() => {
    let newTableColumns = columns(
      location,
      navigate,
      dispatch,
      handleSearchQuery,
      tenantName
    );
    setTableColumns(newTableColumns);
  }, [columns, location, navigate, dispatch, tenantName]);

  return (
    <DataTable
      columns={tableColumns}
      defaultData={data}
      setDefaultData={setData}
      data={updatedData}
      setData={setUpdatedData}
      totalRows={totalRows}
      loading={loading}
      uniqueFieldName={"ID"}
      fetchMoreData={handleCurrentPage}
      searchable
      setSearchQuery={handleSearchQuery}
      placeholder={searchPlaceHolder}
    />
  );
};

export default MyModerations;
